import { injectIntl } from "react-intl";
import apiService from "src/services/api.service";

const DeleteCreative = (props) => {
  const ids = Array.isArray(props.ids) ? props.ids.filter(Boolean) : [];
  const count = ids.length;

  const deleteCreatives = () => {
    if (!count) {
      return;
    }
    Promise.all(ids.map((id) => apiService.deleteCreative(id))).then(() => {
      props.onDeleted?.();
      props.close();
    });
  };

  return (
    <div className="NewStrategyModalOverlay">
      <div className="DeleteStrategyModal">
        <div className={"w-full flex justify-between"}>
          <div className={"DeleteStrategy"}>
            <img
              alt={"Logo"}
              src={"/media/icons/deleteIcon.svg"}
              className={"w-[18px] h-[18px]"}
            />
            Delete Creatives from Schedsmart?
          </div>
          <button className={"CloseIconButton"} onClick={props.close}>
            <img
              alt={"Logo"}
              src={"/media/icons/closeIcon.svg"}
              className={"w-5 h-5"}
            />
          </button>
        </div>
        <div className={"flex flex-col gap-4 w-full"}>
          <div className={"HorizontalDivider"}></div>
          <div className={"StrategyDeleteWarning"}>
            Are you sure you want to delete this creatives from Schedsmart? This
            action cannot be undone.{" "}
          </div>
          <div className={"HorizontalDivider"}></div>
        </div>
        <div className={"modal-actions"}>
          <button className={"CloseButton"} onClick={props.close}>
            Cancel
          </button>
          <button className={"DeleteButton"} onClick={deleteCreatives}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(DeleteCreative);
